import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddRoom, EditRoom, RoomParams, RoomWithPage } from '@app/interfaces/rm/location-room';
import { SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocationRoomService {
    private baseUrl = environment.api.services.rm + '/location-rooms';

    constructor(private http: HttpClient) {
    }

    async find(params: RoomParams): Promise<RoomWithPage> {
        return lastValueFrom(this.http.get<RoomWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }

    async options(params?: { locationLabId: number, locationFloorId?: number }): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`, {
            params: params ? Object.assign(params) : {}
        }));
    }


    async add(params: AddRoom): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, params));
    }

    async edit(data: EditRoom): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
    }

    async remove(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }
}
